import { apiPath } from '../../constants';
import { axios, apiRequestOptions, transformHttpResponse, errorRequestHandler } from 'utils';

export const WORKSPACE_REQUEST = 'TATAMI_WORKSPACE_REQUEST';
export const WORKSPACE_SUCCESS = 'TATAMI_WORKSPACE_SUCCESS';
export const WORKSPACE_FAILURE = 'TATAMI_WORKSPACE_FAILURE';

/**
 * ONE mat's workspace.
 *
 * The response is the slice a secretary needs, assembled by the backend and
 * refused outright for a mat they are not assigned to — changing the numbers
 * in the URL cannot widen it.
 */
export const fetchTatamiWorkspace = (competitionId, day, tatamiNumber) => dispatch => {
    if (!competitionId || !day || !tatamiNumber) {
        return Promise.resolve();
    }

    const key = `${competitionId}:${day}:${tatamiNumber}`;
    dispatch({ type: WORKSPACE_REQUEST, key });

    return axios(apiRequestOptions(apiPath.OPERATIONS.WORKSPACE, {}, { params: { competitionId, day, tatamiNumber } }))
        .then(transformHttpResponse)
        .then(response => dispatch({ type: WORKSPACE_SUCCESS, key, data: response.data }))
        .catch(error => {
            dispatch({ type: WORKSPACE_FAILURE, key });
            dispatch(errorRequestHandler(error));
        });
};
